import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { conversationsAtom, frameParamsAtom } from 'src/app/state/atoms';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { sendConversationStartedEvent } from 'src/app/lib/google-analytics';
import { isTelemetryEnabled } from 'src/app/utils/getTelemetrySwitch';
import { getRuntimeEnvironment } from 'src/app/utils/getRuntimeEnvironment';

function useConversationStarted() {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [frameParams] = useRecoilState(frameParamsAtom);
  const [conversations] = useRecoilState(conversationsAtom);

  useEffect(() => {
    if (conversations.data.id && !isTelemetryEnabled() && getRuntimeEnvironment() === 'prod') {
      sendConversationStartedEvent(conversations, frameParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [conversations.data.id]);
}

export default useConversationStarted;
